import { AsyncPipe } from "@angular/common";
import { inject } from "@angular/core";
import { RouterLink } from "@angular/router";
import { UiIconComponent } from '@common/ui/frontend-shared/icons';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import { RouterLinkResolverPipe } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import { MaintenanceState } from "../state/maintenance.state";
import * as i0 from "@angular/core";
function MaintenanceInfoIconComponent_Conditional_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner", 3);
  }
  if (rf & 2) {
    i0.ɵɵproperty("size", 20)("margin", false);
  }
}
function MaintenanceInfoIconComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵpipe(1, "resolveRouterLink");
    i0.ɵɵelement(2, "ui-icon", 2);
    i0.ɵɵtemplate(3, MaintenanceInfoIconComponent_Conditional_0_ng_template_3_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 1, "maintenance"));
  }
}
// import { NotificationsState } from '../state/notifications.state';
export let MaintenanceInfoIconComponent = /*#__PURE__*/(() => {
  class MaintenanceInfoIconComponent {
    constructor() {
      this.maintenanceMode$ = inject(Store).select(MaintenanceState.maintenanceMode);
    }
    static {
      this.ɵfac = function MaintenanceInfoIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MaintenanceInfoIconComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MaintenanceInfoIconComponent,
        selectors: [["maintenance-info-icon"]],
        decls: 2,
        vars: 3,
        consts: [["loading", ""], ["id", "iconwrapper", "title", "Wartungsmodus aktiv!", 3, "routerLink"], ["icon", "wrench", "size", "2x"], [1, "spinner", 3, "size", "margin"]],
        template: function MaintenanceInfoIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, MaintenanceInfoIconComponent_Conditional_0_Template, 5, 3, "a", 1);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.maintenanceMode$) ? 0 : -1);
          }
        },
        dependencies: [RouterLink, UiIconComponent, UiSpinnerComponent, AsyncPipe, RouterLinkResolverPipe],
        styles: ["#iconwrapper[_ngcontent-%COMP%]{position:relative;display:inline-block;color:var(--maintenanceWarningColor)}#iconwrapper[_ngcontent-%COMP%]    >ui-icon{display:block}.spinner[_ngcontent-%COMP%]{position:absolute;top:14px;left:13px;width:20px;height:20px}"]
      });
    }
  }
  return MaintenanceInfoIconComponent;
})();